import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: "default" | "error" | "complete" | "border-none";
  size?: "default" | "lg";
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    const getVariantClasses = () => {
      switch (variant) {
        case "error":
          return "wl-textarea-error";
        case "complete":
          return "wl-textarea-complete";
        case "border-none":
          return "wl-textarea-border-none";
        default:
          return "";
      }
    };

    const getSizeClasses = () => {
      switch (size) {
        case "lg":
          return "wl-textarea-lg";
        default:
          return "";
      }
    };

    return (
      <textarea
        ref={ref}
        data-slot="textarea"
        className={cn(
          "wl-textarea",
          getVariantClasses(),
          getSizeClasses(),
          className
        )}
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };
